import { colors } from '../../colors';
var socialFeed = {
  postTextColor: colors.charcoalGrey,
  primaryColor: colors.dustyTeal,
  feedBgColor: colors.white,
  headlineUppercase: false,
  subHeadlineUppercase: true
};
export default socialFeed;